import React, { FC } from 'react';
import { Box, TextField } from '@mui/material';
import { SearchIcon } from '@utils/iconsDefs';

type SearchFieldProps = {
  search: string;
  setSearch: (value: string) => void;
};

const SearchField: FC<SearchFieldProps> = ({ search, setSearch }) => {
  return (
    <Box py={2} px={3}>
      <TextField
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by entity name ..."
        InputProps={{
          startAdornment: (
            <Box mr={2} pt="2px">
              <SearchIcon />
            </Box>
          ),
        }}
        sx={{ width: '100%' }}
      />
    </Box>
  );
};

export default SearchField;
